// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.g0MFq{display:flex;flex-direction:column;gap:0;width:100%;height:100%}.rUjA4 .g0MFq{height:auto}.jjnzO{padding:0 0 16px}.LqJiN{display:flex;flex-direction:column;overflow-y:auto;min-height:0;flex:1}.rUjA4 .LqJiN{overflow:visible;min-height:auto;flex:initial}.iCOt9{width:100%;padding:0}.ll5u8{width:100%;padding:0}.fWjXA{position:relative;max-width:800px;--custom-page-template-content-height: min(600px, calc(100vh - 200px))}@media(max-width: 800px){.fWjXA{max-width:100%;--custom-page-template-content-height: min(400px, calc(100vh - 200px))}}.fWjXA.rUjA4{display:flex;flex-direction:column;flex:1;min-height:0;max-width:100%}.fWjXA.rUjA4.ug_U6{min-height:560px}.fWjXA.rUjA4.ug_U6>[data-testid=bottom-sheet-header-slot]+div{display:flex;flex-direction:column}.fWjXA.rUjA4.ug_U6>[data-testid=bottom-sheet-header-slot]+div>*{flex:1;min-height:0}.t_OU6{position:absolute;left:24px;top:18px;z-index:2}.TYSkp{padding:8px 40px 0 40px}@media(max-width: 600px){.TYSkp{padding:8px 16px 0 16px}}.VnHCc{position:relative;overflow:hidden;width:100%;height:var(--custom-page-template-content-height)}.mzUD5{width:100%;height:100%;transition:transform 300ms ease-in-out,opacity 200ms ease-in-out}.NI_o8{position:absolute;top:0;left:0;width:100%;height:100%;transform:translateX(100%);opacity:0}.cbZ37{transform:translateX(-100%);opacity:0;pointer-events:none}.wNVLn{transform:translateX(0);opacity:1}.IwrID{margin-top:auto;padding-top:8px}.rUjA4 .IwrID{margin-top:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"bodyContent": `g0MFq`,
	"inBottomSheet": `rUjA4`,
	"searchWrapper": `jjnzO`,
	"templateList": `LqJiN`,
	"emptyState": `iCOt9`,
	"noResults": `ll5u8`,
	"modalWrapper": `fWjXA`,
	"formView": `ug_U6`,
	"backButton": `t_OU6`,
	"contentArea": `TYSkp`,
	"slideContainer": `VnHCc`,
	"slidePanel": `mzUD5`,
	"formPanel": `NI_o8`,
	"slideOut": `cbZ37`,
	"slideIn": `wNVLn`,
	"listFooter": `IwrID`
};
export default ___CSS_LOADER_EXPORT___;
